module.exports = __webpack_public_path__ + "assets/antilock-braking-system.e1d3336c.svg";